export const formatNumber = number => {
  const isNumber = /\d+/.test(number);
  if (!isNumber) return number;

  return parseFloat(number).toFixed(2).replace(".00", "");
};
